import type { ReactNode } from 'react';
import styles from './CenteredPage.module.css';

/** Full-screen centered layout for sign-in, onboarding and error screens. */
export function CenteredPage({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <main id="main" className={styles.page}>
      <div className={[styles.inner, wide && styles.wide].filter(Boolean).join(' ')}>{children}</div>
    </main>
  );
}
